import { render, staticRenderFns } from "./winning.vue?vue&type=template&id=63f05652&scoped=true&"
import script from "./winning.vue?vue&type=script&lang=js&"
export * from "./winning.vue?vue&type=script&lang=js&"
import style0 from "./winning.vue?vue&type=style&index=0&id=63f05652&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f05652",
  null
  
)

export default component.exports